export default __webpack_public_path__ + "static/media/13t.7cbf8864.jpg";